import { FeedbackTypes } from 'context/materialUI/types'
import { PreferredContactType } from 'layouts/feedback/types'

export const PREFERRED_CONTACT_TYPE_OPTIONS: PreferredContactType[] = ['PHONE', 'EMAIL']

export const ALLOWED_FILE_TYPES = [
	// Documents
	'application/pdf',
	'application/msword',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

	// Images
	'image/png',
	'image/jpeg',
	'image/heic',
	'image/heif',

	// Audio
	'audio/mpeg', // .mp3
	'audio/wav', // .wav

	// Video
	'video/mp4', // .mp4
	'video/quicktime', // .mov
	'video/mpeg', // .mpeg
]

export const ALLOWED_ATTACHMENT_INPUT_TYPES =
	'.pdf,.doc,.docx,.png,.jpg,.jpeg,.heic,.heif,.mp3,.wav,.mp4,.mov,.mpeg'

export const MAX_FILE_SIZE_MB = 10
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

export const FEEDBACK_TYPE_OPTIONS: FeedbackTypes[] = ['COMPLAINT', 'COMMENDATION']
